import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {BibliotecaFormularioComponent} from "../../../bibliotecaPjus/componentes/biblioteca-formulario.component";
import {DocumentoEnum} from "../../../aplicacao/enum/documentos.enum";
import {ActivatedRoute, Router} from "@angular/router";
import {AlertaService} from "../../../bibliotecaPjus/services/alerta.service";
import {DeviceDetectorService} from "../../../core/services/device-detector.service";
import {EnvioCndsService} from "../../../services/envio-cnds.service";
import {ParceriaService} from "../../../services/nova-parceria/parceria.service";
import {NgxSpinnerService} from "ngx-spinner";
import {TipoFormulario} from "../../../bibliotecaPjus/enums/enumGenerico.enum";
import {DocumentoEnvioLocal} from "../../../aplicacao/models/documento-envio-local.model";

@Component({
  selector: 'app-envio-documento-local',
  templateUrl: './envio-documento-local.component.html',
  styleUrls: ['./envio-documento-local.component.scss']
})
export class EnvioDocumentoLocalComponent extends BibliotecaFormularioComponent<DocumentoEnvioLocal> implements OnInit, OnDestroy {
  selectedFiles;
  nomeArquivo;
  @Input() envioAutomatico = false;
  @Input() indexSocio = 0;
  @Output() retorno = new EventEmitter();
  @Output() objArquivo = new EventEmitter();
  @Input() tipoDocumento = DocumentoEnum.getTypes().filter(tipo =>
    ['Oficio', 'OutrosDocumentosRelevantes', 'PlanilhaDeCalculo', 'CopiaPrecatorio'].includes(tipo.key)
  );
  // @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  @Input() propostaId: string = '';
  @Input() documentoEnvioAceiteProposta: string = '';
  @Input()
  set envioDocumento(value: any) {
    this.tratarEnvioDocumento(value);
  }

  get envioDocumento(): any {
    return null; //this._envioDocumento;
  }

  tratarEnvioDocumento(value: any) {
    console.log('tratarEnvioDocumento', this.indexSocio);
    if (value) {
      // if (this.fileInput && this.fileInput.nativeElement) {
      //   this.fileInput.nativeElement.click();
      // }
      const elemento = document.getElementById('file'+this.indexSocio);
      if (elemento) {
        elemento.click();
      }
      if (this.form && this.form.controls) {
        this.form.controls.tipoDocumento.setValue(value);
        this.form.controls.nomeExterno.setValue(value);
      }
    }
  }

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected alertaService: AlertaService,
    protected deviceDetectorService: DeviceDetectorService,
    protected envioCndsService: EnvioCndsService,
    protected parceriaService: ParceriaService,
    protected ngxSpinnerService: NgxSpinnerService,
  ) {
    super(
      router,
      route,
      alertaService,
      envioCndsService,
      ['Novo envio de Documento', 'Editar envio de Documento'],
      ['Documento enviado com sucesso.', 'Documento editada com sucesso.']
    );
    const novaProposta = new DocumentoEnvioLocal();
    this.loaded(novaProposta, TipoFormulario.Criar);
    this.salvarLocal = true
  }

  ngOnInit() {
    super.ngOnInit();
    this.model.form.statusChanges.subscribe(status => {
      this.retorno.emit();
    });
  }


  antesEnviar(): void {
    this.validarFormulario = false;
    if (this.form.valid){
      this.validarFormulario = true;
    }
  }

  uploadArquivo(event): void {
    this.selectedFiles = event;
    if (this.selectedFiles.target.files && this.selectedFiles.target.files[0]) {
      const file = this.selectedFiles.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        const r = e.target.result;
        if (typeof e.target.result === 'string') {
          const base64String = e.target.result.split(',').pop();
          this.nomeArquivo = file.name;
          this.form.controls.base64.setValue(base64String);
          this.form.controls.extensaoArquivo.setValue(file.name.split('.').pop().toLowerCase());
          if(this.envioAutomatico) {
            this.enviar();
          }
        }
      };
      reader.readAsDataURL(file);
    }
  }

  depoisEnviar(model: DocumentoEnvioLocal) {
    super.depoisEnviar(model);
    this.objArquivo.emit(model);
    this.retorno.emit();
    this.form.reset();
    // Resetando formulario
    this.selectedFiles = null;
    this.nomeArquivo = null;
    // if (this.fileInput && this.fileInput.nativeElement) {
    //   this.fileInput.nativeElement.value = '';
    // }

    this.navegar = false;
  }

  tipoDocumentoSelecionado(ev): void {
    this.form.controls.tipoDocumento.setValue(ev);
  }
}
